

<template>
    <div class="container-fluid px-0">
    <div class="row mx-0">
      <div class="col-12">
        <div class="py-1 ">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header pb-0">
                  <div class="align-items-center">
                    <p class="mb-0 text-lg text-center text-black">
                      VAT Refund Application for Tourists
                    </p>
                  </div>
                </div>
                <div class="card-body">
                
                  <div class="row">
                    <div class="col-md-12">
                      <label for="receiptsCode" class="form-control-label">
                        Receipt No. / Order No.</label>
                      <InputText v-model="receiptsCode" type="text" 
                      placeholder="Receipt No. / Order No. (1)" 
                        :class="{ 'is-invalid': receiptError }"
                      />
                        <small v-if="receiptError" class="text-danger">{{ receiptError }}</small>
                    </div>
                    <div class="col-md-12">
                      <label for="storeNumber"  class="form-control-label">Store No.</label>
                      <InputText v-model="storeNumber" type="text"
                      placeholder="5 digit store number (2)" 
                      :class="{ 'is-invalid': storeError }"
                      
                      />
                        <small  v-if="storeError" class="text-danger">{{ storeError }}</small>
                    </div>
                  
                  </div>
                
                  <hr class="horizontal dark" />
                    <div class="row">
                      <div class="col-md-6">
                          <GlobalButtonPrv @click="handleClickClear">
                          Clear <i class="fa fa-trash" aria-hidden="true"  style="font-size: 18px; margin-left:5px;"></i>

                          </GlobalButtonPrv>
                      </div>
                      <div class="col-md-6">
                        <GlobalButtonNext @click="handleClickNextPage" :disabled="isSending">
                        Next <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                        </GlobalButtonNext>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
            <div class="col-12 mt-4 md-2 " >
                <div class="row px-3">
                  <small class="" style="color:red;"> Important Note : Goods must be purchased at least 2,000 Baht (VAT included) per day per store. </small>
                </div>
              </div>
            </div>
      
          </div>
          <div class="row mt-2">
              <div class="col-md-12">
                <img :src="receiptExamplePage" class="img-full-width"/>
            </div>
          </div>
        </div>

     </div>
    </div>
  </div>

    <!-- <div class="row mt-3">
      <div class="col-md-3">
        <button class="btn btn-warning w-100" @click="showModalCase(1)">Test Case 1</button>
      </div>
    </div> -->
  <PopupModal
    :visible="isModalVisible"
    :title="modalTitle"
    :message="modalMessage"
    :subMessage="modalSubMessage"
     :closeText="'Close'"
    @close="isModalVisible = false"
  />
</template>

<script setup>
import { computed,ref ,watch} from 'vue';
import receiptExamplePage from '@/assets/img/icons/pages/receipt_ex.png';
import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
import PopupModal from "@/components/global/ModalAlert.vue"; 

import InputText from "@/components/global/InputText.vue";
import { useReceiptStoreEvrt } from '@/store/useReceiptStoreEvrt';
///
import { fetchGetOrderReceiptEvrt} from '@/service-api/request-api-evrt';
//language // 
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);
//End language // 
const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);

const receiptStore = useReceiptStoreEvrt();

const receiptsCode = computed({
  get: () => receiptStore.receiptsCode,
  set: (val) => (receiptStore.receiptsCode = val),
});

const storeNumber = computed({
  get: () => receiptStore.storeNumber,
  set: (val) => (receiptStore.storeNumber = val),
});
const handleClickClear = () => {
  window.location.reload();
};


const receiptError = ref('');
const storeError = ref('');

const isSending = ref(false);

const handleClickNextPage = async () => {
  if (isSending.value) return; // ป้องกันกดซ้ำ
    isSending.value = true; // ปิดปุ่มก่อน


  receiptError.value = '';
  storeError.value = '';

  const receipt = receiptsCode.value?.trim();
  const store = storeNumber.value?.trim();

  let hasError = false;

  if (!receipt) {
    receiptError.value = "Please enter Receipt No. / Order No. ";
    hasError = true;
  }

  if (!store) {
    storeError.value = "Please enter Store No.";
    hasError = true;
  }
   if (hasError) {
    isSending.value = false; // เปิดปุ่มคืนถ้ามี error
    return;
  }
  //if (hasError) return;

  try {
    const response = await fetchGetOrderReceiptEvrt({
      receipt_code: receipt,
      store_code: store,
    });

    // if (response.fail_case) {
    //   showModalCase(response.fail_case);
    //   return;
    // }

    if (response.fail_case) {
     
      // if (response.fail_case === 7) {
      //   receiptStore.$patch({
      //     receiptsCode: receipt,
      //     storeNumber: store,
      //   });
      //   emit('next');
      //   return;
      // }

      showModalCase(response.fail_case);
      return;
    }


    receiptStore.$patch({
      receiptsCode: receipt,
      storeNumber: store,
    });

    emit('next');

  } catch (error) {
    console.error('API Error:', error);
  modalTitle.value = "Error";
  modalMessage.value = error.message || "Unable to connect to the server. ";
  isModalVisible.value = true;
  }
  finally {
    isSending.value = false; 
  }
};



const isModalVisible = ref(false);
const modalMessage = ref('');
const modalSubMessage = ref('');
const modalTitle = ref('');

const modalCases = computed(() => ({
  1: {
    message: "Your Receipt number or Store number is incorrect. ",
  },
  2: {
    message: "Your Receipt number is incorrect.Please check again.",
  },
  3: {
    message: "Your Receipt number or Store number is incorrect.",
  },
  4: {
    message: "There's already a request for this Receipt / Order No. <br> ",
    subMessage: "If you have any questions please contact the stores",
  },
  5: {
    message: "Electronic Full Tax Invoice should be requested with complete details within 3 days of purchasing/receiving",
  },
  6: {
    message: "Electronic Full Tax Invoice should be requested with complete details within 10 days of purchasing/receiving.",
  },
  7: {
    message: "The total order amount is less than 2,000 Bath.",
  },
  8: {
    message: "Your receipt is outdated. Please submit an e-VRT application within the same day of purchase",
  },
}));




// const showModalCase = (caseNumber) => {
//   const caseData = modalCases.value[caseNumber];
//   modalTitle.value = "Error"; 
//   modalMessage.value = caseData.message || '';
//   modalSubMessage.value = caseData.subMessage || '';
//   isModalVisible.value = true;
// };
const showModalCase = (caseNumber) => {
  const caseData = modalCases.value[caseNumber];

  modalTitle.value = "Error";

  if (caseNumber === 4) {
    modalMessage.value =
      `There's already a request for this Receipt / Order No. <br>(${receiptsCode.value})`;
  } else {
    modalMessage.value = caseData.message || '';
  }

  modalSubMessage.value = caseData.subMessage || '';
  isModalVisible.value = true;
};


watch(receiptsCode, (newVal) => {
  if (receiptError.value && newVal?.trim()) {
    receiptError.value = '';
  }
});

watch(storeNumber, (newVal) => {
  if (storeError.value && newVal?.trim()) {
    storeError.value = '';
  }
});
</script>

<style scoped>


.img-full-width {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  padding: 10px;
  box-sizing: border-box; 
}


.pd-10 {
  padding: 10px;
}

.mr-2{
  margin-right: 2px;

} 
.ml-2{
margin-left: 2px;
}

.mr-4{
  margin-right: 4px;

} 
.ml-4{
margin-left: 4px;
}

.mr-12{
  margin-right: 12px;

} 
.ml-12{
margin-left: 12px;
}

html, body {
  overflow-x: hidden !important;
}
html, body, #app {
  padding: 0 !important;
  margin: 0 !important;
}


</style>